import React, { useState, useContext } from "react";
import { MyContext } from "../State/ProviderData";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";

const Basket = () => {
  const [myData, setMyData] = useContext(MyContext);

  const [keyRefresh, setKeyRefresh] = useState(new Date());
  // const localBasket = localStorage.getItem("basket");
  // const [basket, setBasket] = useState([localBasket]);
  // const [keyRefresh, setKeyRefresh] = useState(new Date());

  const removeEvent = (epreuve) => {
    setMyData(() =>
      myData.filter((e) => e != null).filter((item) => item.id !== epreuve.id)
    );
    if (myData) {
      const dt = myData
        .filter((e) => e != null)
        .filter((item) => item.id !== epreuve.id);
      localStorage.setItem("basket", JSON.stringify(dt), null);
    }
  };

  return (
    <div>
      <h2>Ma sélection de triathlons</h2>
      <ul>
        {myData
          .filter((e) => e != null)
          .map((eventItem, index) => (
            <li key={keyRefresh} className="row">
              <span className="col-md-6">{eventItem.name}</span>
              <span className="col-md-1">
                <DeleteForeverIcon
                  className="ml-2"
                  onClick={() => removeEvent(eventItem)}
                />
              </span>
            </li>
          ))}
      </ul>
    </div>
  );
};

export default Basket;
